// Which company (tenant) this browser tab belongs to, in SaaS mode.
//
// Each company is served on its own subdomain: acme.<root domain> (locally acme.localhost:3030).
// The bare root domain serves the Qayd site and sign-up. The slug is sent to the API as
// `X-Tenant` with every request.
//
//   REACT_APP_SAAS_MODE=true
//   REACT_APP_SAAS_ROOT_DOMAIN=qayd.app        (locally: localhost)
const env = process.env;

export const SAAS_MODE = env.REACT_APP_SAAS_MODE === "true";
export const ROOT_DOMAIN = (env.REACT_APP_SAAS_ROOT_DOMAIN || "localhost").toLowerCase();

/** The company slug from a hostname, or null on the root domain. */
export function slugFromHostname(hostname) {
  const host = String(hostname || "").toLowerCase();
  if (!host.endsWith(`.${ROOT_DOMAIN}`)) return null;
  const sub = host.slice(0, -(ROOT_DOMAIN.length + 1));
  if (!sub || sub.includes(".") || sub === "www") return null;
  return sub;
}

// admin.<root domain> is the Qayd console, a separate app (SaaS_Admin_Frontend); "admin" is never a company.
export const TENANT_SLUG = SAAS_MODE && typeof window !== "undefined" ? slugFromHostname(window.location.hostname) : null;

/** Absolute URL of a page on a company's own address, e.g. companyUrl("acme", "/login"). */
export function companyUrl(slug, path = "/") {
  const { protocol, port } = window.location;
  return `${protocol}//${slug}.${ROOT_DOMAIN}${port ? `:${port}` : ""}${path}`;
}

/** Absolute URL on the root domain (the Qayd site / sign-up). */
export function rootUrl(path = "/") {
  const { protocol, port } = window.location;
  return `${protocol}//${ROOT_DOMAIN}${port ? `:${port}` : ""}${path}`;
}
